export const getImageSizeForMaxSize = (size: {width: number; height: number}, maxSize: {width: number; height: number}) => {
    const xScale = size.width / maxSize.width;
    const yScale = size.height / maxSize.height;

    const scale = xScale > yScale ? xScale : yScale;

    return {
        width: size.width / scale,
        height: size.height / scale,
    };
};
